export const SITE_URL = 'https://marketingcalculatorhub.com';
export const LOGO_URL = `${SITE_URL}/logo.png`;

export const CALCULATOR_PATHS = {
  // Customer Metrics
  CPC: 'cost-per-click',
  CPA: 'cost-per-acquisition',
  ROI: 'roi',
  CAC: 'customer-acquisition-cost',
  CLV: 'customer-lifetime-value',

  // Web Analytics
  CONVERSION_RATE: 'conversion-rate',
  BOUNCE_RATE: 'bounce-rate',
  LANDING_PAGE_CONVERSION: 'landing-page-conversion-rate',

  // Advertising Metrics
  CPM: 'cost-per-mille',
  ROAS: 'return-on-ad-spend',
  ECPM: 'effective-cost-per-mille',

  // Email Marketing
  EMAIL_OPEN_RATE: 'email-open-rate',
  EMAIL_CTR: 'email-click-through-rate',
  EMAIL_UNSUBSCRIBE: 'email-unsubscribe-rate',
  EMAIL_ROI: 'email-campaign-roi',
  NEWSLETTER_CHURN: 'newsletter-churn-rate',

  // Social Media
  SOCIAL_MEDIA_ROI: 'social-media-roi',
  SOCIAL_ENGAGEMENT: 'social-media-engagement-rate',

  // Content Marketing
  CONTENT_ROI: 'content-marketing-roi',
  BLOG_READ_RATE: 'blog-post-read-rate'
} as const;

export const getCalculatorUrl = (path: string) => `${SITE_URL}/calculators/${path}`; 